<template>
    <div class="relative flex items-center">
        <div class="flex items-center h-4">
            <input
                :id="id"
                type="checkbox"
                class="
                    cursor-pointer
                    h-5
                    w-5
                    text-gray-300
                    border-gray-300
                    rounded
                    focus:ring-0
                    focus:ring-offset-0	
                    focus:outline-0
                    focus:outline-offset-0	
                    checked:border-primary-600
                "
                :checked="isChecked"
                @change="$emit('update:modelValue', $event.target.checked)"
                :disabled="disabled"
            />
        </div>
        <template v-if="defaultSlot">
            <div class="ml-3 text-sm">
                <label
                    :for="id"
                    class="cursor-pointer text-primary-900 text-sm"
                >
                    {{ label }}
                </label>
            </div>
        </template>
        <slot v-else></slot>
    </div>
</template>

<script setup lang="ts">
defineProps({
    isChecked: {
        type: Boolean,
        default: false,
    },
    defaultSlot: {
        type: Boolean,
        default: true,
    },
    modelValue: {
        default: null,
        required: true,
    },
    id: {
        type: String,
    },
    label: {
        type: String,
    },
    rounded: {
        type: Boolean,
        default: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    textColor: {
        type: String,
    },
});
</script>
